const actionScope = '[Location Countries]';

export class LoadCountries {
  static readonly type = `${actionScope} Load Countries`;
}

export class LoadCountriesIfNotLoaded {
  static readonly type = `${actionScope} Load Countries If Not Loaded`;
}
